var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ConnectionNames } from "../../contracts";
import { BaseRESTConnection } from "../../common";
export class Stadium extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.stadium, meta);
    }
    /**
     * Obsolete - migrate to SingleEventRequestResolver
     */
    getEventCategoriesData(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.applyQuery({
                name: "getEventCategories",
                params
            });
        });
    }
    /**
     * Obsolete - migrate to SingleEventRequestResolver
     */
    getEventCategoryData(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.applyQuery({
                name: "getEventCategoryData",
                params
            });
        });
    }
    /**
     * Obsolete - migrate to MultiEventRequestResolver
     */
    getLeagueData(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.applyQuery({
                name: "getLeagueData",
                params
            });
        });
    }
    /**
     * Obsolete - migrate to MultiEventRequestResolver
     */
    getCategoryData(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.applyQuery({
                name: "getCategoryData",
                params
            });
        });
    }
    /**
     * Obsolete - migrate to MultiEventRequestResolver
     */
    getSubCategoryData(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.applyQuery({
                name: "getSubCategoryData",
                params
            });
        });
    }
}
//# sourceMappingURL=Stadium.js.map